import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProjectsCategoriesViewRoute: InvariantJiraRoute = {
	name: 'global-settings-projects-categories-view',
	path: '/secure/admin/projectcategories/ViewProjectCategories([!%]?[\\w]*).jspa',
};
